import { SupportedChainId } from '@orionprotocol/sdk';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  WalletChangeNetworkCancelled,
  WalletChangeNetworkFailed,
} from '@orionprotocol/wallet-api';
import { i18n } from '@lingui/core';
import { useToast } from '@orionprotocol/ui';

import { getAvailableNetworks } from '../redux/selectors';

import { useWalletAPI } from './useWalletAPI';

export function useChangeWalletNetwork({
  onSuccess,
  onCancelled,
  onFailed,
}: {
  onSuccess?: () => void;
  onCancelled?: () => void;
  onFailed?: () => void;
} = {}): (chainId: SupportedChainId) => Promise<void> {
  const walletAPI = useWalletAPI();
  const availableNetworks = useSelector(getAvailableNetworks);
  const { showToast } = useToast();

  const changeWalletNetwork = useCallback(
    async (chainId: SupportedChainId): Promise<void> => {
      if (walletAPI?.changeNetwork) {
        const chainInfo = availableNetworks[chainId];
        if (!chainInfo) return;

        try {
          await walletAPI.changeNetwork(chainInfo);

          onSuccess?.();
        } catch (e) {
          console.error(e);
          if (e instanceof WalletChangeNetworkCancelled) {
            onCancelled?.();
            showToast({
              // iconType: 'error',
              text: i18n._('User rejected the request'),
            });
          } else if (e instanceof WalletChangeNetworkFailed) {
            onFailed?.();

            // if (utils.isWithMessage(e)) {
            //     showToast({
            // //       iconType: 'error',
            //       text: e.message,
            //     });
            //   );
          }
        }
      }
    },
    [availableNetworks, onCancelled, onFailed, onSuccess, showToast, walletAPI],
  );

  return changeWalletNetwork;
}
